// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/CustomFooter";

// About Us page sections
import Information from "pages/LandingPages/ContactUs/sections/information";
import Map from "pages/LandingPages/ContactUs/sections/map";
//import Team from "pages/LandingPages/AboutUs/sections/Team";
//import Featuring from "pages/LandingPages/AboutUs/sections/Featuring";
//import Newsletter from "pages/LandingPages/AboutUs/sections/Newsletter";

// Routes
import routes from "routes";
//import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/Contact1.jpg";

function ContactUs() {
  return (
    <>
      <DefaultNavbar routes={routes} transparent light />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.7),
              rgba(gradients.dark.state, 0.7)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Contact Us
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.9} mt={1} mb={0}>
              Let’s make your underwater adventure a reality — contact us today!
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.9} mt={1} mb={0}>
              We make the best for all our customers with a smile....
            </MKTypography>
            <MKBox display="flex" justifyContent="center" alignItems="center">
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-facebook" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-instagram" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-twitter" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#">
                <i className="fab fa-google-plus" />
              </MKTypography>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={8}>
          <Container>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={50} md={32}>
                <Grid container justifyContent="flex-start">
                  <MKTypography variant="body1" mt={1} mb={0}>
                    Our friendly team is here to help you every step of the way — from choosing the
                    right dive package to sharing local tips for your stay in Sri Lanka. Whether you
                    prefer to call, email, or drop by our dive center, we’re always happy to hear
                    from you.
                  </MKTypography>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <Information />
        <Map />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter />
      </MKBox>
    </>
  );
}

export default ContactUs;
